import type { RTCOViewHotelPayload, RTCOViewHotelResponse } from '@/app/api/search/rtcoviewhotel/rtclViewHotel.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { API_NAME } from '@/app/components/search/common/apiTypes.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { Localization } from '../common/Localization';
import { isNil } from '../Utilities';
import clientAPICall from '../common/clientAPICall.ts';

type RTCOClientViewHotel = {
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  localization: Localization;
  hotelId: number;
  position?: number;
  commonData: CommonData;
};
const rtcoClientViewHotel = async ({
  searchParams,
  searchInfoData,
  localization,
  hotelId,
  position,
  commonData,
}: RTCOClientViewHotel) => {
  const payload: RTCOViewHotelPayload = {
    searchMode: searchInfoData.searchMode,
    localization,
    dateFrom: searchParams[URLParameters.DATE_FROM],
    dateTo: searchParams[URLParameters.DATE_TO],
    adults: searchParams[URLParameters.ADULTS],
    childrenAges: searchParams[URLParameters.AGES],
    hotelId: isNil(hotelId) ? '' : `${hotelId}`,
    position: isNil(position) ? '' : `${position}`,
  };
  await clientAPICall<RTCOViewHotelPayload, RTCOViewHotelResponse>({
    apiName: API_NAME.RTCO_VIEW_HOTEL,
    payload,
    traceParent: searchInfoData.searchTraceParent,
    commonData,
  });
};

export default rtcoClientViewHotel;
